import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Container, Wrapper, Copy } from "app/NativeComponents/common";
import {
  NewHeader,
  SpinWrapper,
  List,
  SelectItem,
  InlineTabs
} from "app/NativeComponents/snippets";
import {
  popSidePanel,
  pushSidePanel,
  renderDate,
  getTeam
} from "app/NativeActions";

class DialerLicenses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: "dialer"
    };
  }

  componentDidMount() {
    if (!this.props.team_loading && this.props.my_team?.length === 0) {
      this.props.getTeam({ token: this.props.token, type: "load" });
    }
  }

  render() {
    const dialer_seats =
      (this.props.source_of_truth?.dialer_seats &&
        this.props.source_of_truth?.dialer_seats.filter(
          seat => seat.seat_type === "dialer"
        )) ||
      [];
    const voicemail_seats =
      (this.props.source_of_truth?.dialer_seats &&
        this.props.source_of_truth?.dialer_seats.filter(
          seat => seat.seat_type === "voicemail"
        )) ||
      [];
    return (
      <Container>
        <NewHeader
          title={"Dialer Licenses"}
          leftButton={{
            icon: "arrow-back",
            onPress: this.props.popSidePanel
          }}
        />
        <InlineTabs
          tab_type="underline"
          selected_tab={this.state.tab}
          tabs={[
            {
              onPress: () => {
                this.setState({
                  tab: "dialer"
                });
              },
              slug: "dialer",
              title: "Unlimited Dialer"
            },

            {
              onPress: () => {
                this.setState({
                  tab: "voicemail"
                });
              },
              slug: "voicemail",
              title: "Unlimited AI Voicemails"
            }
          ]}
        />
        {this.state.tab === "dialer" ? (
          <>
            {dialer_seats?.length === 0 ? (
              <Wrapper
                style={{
                  padding: 25,
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <Copy>
                  You don't have any licenses for unlimited dialer minutes.
                </Copy>
              </Wrapper>
            ) : (
              <List
                rowNumber={1}
                style={{ flex: 1 }}
                items={dialer_seats}
                infiniteScroll={true}
                itemStructure={({ item, index }) => {
                  return (
                    <SelectItem
                      key={"dialer_seat" + index}
                      select_type={"none"}
                      subtext={
                        item.cancel_at
                          ? "Canceled. Valid thru " +
                            moment(item.cancel_at).format("MMM Do, YYYY")
                          : renderDate(item.date_created)
                      }
                      description={"Dialer License"}
                      onPress={() => {
                        this.props.pushSidePanel({
                          slug: "edit_dialer_license",
                          overlay: true,
                          data: {
                            assigned_user: item?.assigned_user,
                            seat_type: "dialer",
                            license_id: item?.id,
                            cancel_at: item?.cancel_at
                          }
                        });
                      }}
                      icon={"keyboard-arrow-right"}
                    >
                      {!!item?.assigned_user && item?.assigned_user != 0
                        ? !!item.firstname
                          ? item.firstname + " " + item.lastname
                          : item.email
                        : "Unassigned License"}
                    </SelectItem>
                  );
                }}
                canRefresh={false}
                onRefresh={() => {}}
                is_refreshing={false}
                canLoadMore={false}
                isLoadingMore={false}
                onLoadMore={() => {}}
              />
            )}
          </>
        ) : this.state.tab === "voicemail" ? (
          <>
            {voicemail_seats?.length === 0 ? (
              <Wrapper
                style={{
                  padding: 25,
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <Copy>
                  You don't have any licenses for unlimited AI voicemails.
                </Copy>
              </Wrapper>
            ) : (
              <List
                rowNumber={1}
                style={{ flex: 1 }}
                items={voicemail_seats}
                infiniteScroll={true}
                itemStructure={({ item, index }) => {
                  return (
                    <SelectItem
                      key={"dialer_seat" + index}
                      select_type={"none"}
                      subtext={
                        item.cancel_at
                          ? "Canceled. Valid thru " +
                            moment(item.cancel_at).format("MMM Do, YYYY")
                          : renderDate(item.date_created)
                      }
                      description={"AI Voicemail License"}
                      icon={"keyboard-arrow-right"}
                      onPress={() => {
                        this.props.pushSidePanel({
                          slug: "edit_dialer_license",
                          overlay: true,
                          data: {
                            assigned_user: item?.assigned_user,
                            seat_type: "voicemail",
                            license_id: item?.id,
                            cancel_at: item?.cancel_at
                          }
                        });
                      }}
                    >
                      {!!item?.assigned_user && item?.assigned_user != 0
                        ? !!item.firstname
                          ? item.firstname + " " + item.lastname
                          : item.email
                        : "Unassigned License"}
                    </SelectItem>
                  );
                }}
                canRefresh={false}
                onRefresh={() => {}}
                is_refreshing={false}
                canLoadMore={false}
                isLoadingMore={false}
                onLoadMore={() => {}}
              />
            )}
          </>
        ) : null}
      </Container>
    );
  }
}

const mapStateToProps = ({ auth, billing, team }) => {
  const { token } = auth;
  const { source_of_truth } = billing;
  const { my_team, team_loading } = team;

  return {
    token,
    source_of_truth,
    my_team,
    team_loading
  };
};

export default connect(mapStateToProps, {
  popSidePanel,
  pushSidePanel,
  getTeam
})(DialerLicenses);
